module.exports = __webpack_public_path__ + "static/img/date.0b2eab60.png";